import { render, staticRenderFns } from "./StoreOverviewGrid.vue?vue&type=template&id=022b8505&scoped=true"
import script from "./StoreOverviewGrid.vue?vue&type=script&lang=js"
export * from "./StoreOverviewGrid.vue?vue&type=script&lang=js"
import style0 from "./StoreOverviewGrid.vue?vue&type=style&index=0&id=022b8505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b8505",
  null
  
)

export default component.exports